<template>
  <div>
    <MasterLayout>
      <div class="pt-5 pb-3 pl-4 pr-3 dashboard_first_row">
        <div class="row">
          <div class="col-md-8">
            <div class="py-5 pt-5 mb-3 row align-items-center white-bg">
              <div class="col-md-1 remove-right-padding col-center-flex">
                <div class="square-icon-wrapper small sky-bg">
                  <!-- <div> -->
                  <img src="@/assets/img/wallet.svg" width="40px" />
                </div>
              </div>
              <div class="py-1 col-md-5">
                <h4 class="primary-color font-600">
                  {{ $t("text.cMasterLayout.companyWallet") }}
                </h4>
                <p class="mt-3 light-grey-text">
                  {{ $t("text.cWallet.description") }}
                </p>
              </div>
              <div class="col-md-6 drop_down_div mt-2">
                <vue-ctk-date-time-picker
                  v-model="dateRange"
                  :max-date="maxDate"
                  :range="true"
                  :autoClose="true"
                  :locale="this.$root.$i18n.locale"
                  :color="$store.getters.getDatePickerColor"
                  format="YYYY-MM-DDTHH:mm:ss"
                  formatted="DD/MM/YYYY"
                  :label="$t('text.calendar.dateRange')"
                />
              </div>

              <div class="col-md-5 flexify"></div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.cWallet.walletBalance") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/wallet.svg" width="40px" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ walletUnit }}{{ convertThousand(walletBalance) }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="invoice-banner mt-3">
          <div class="aggregate_change_input_wrapper w-25">
            <vue-ctk-date-time-picker
              v-model="dateRange"
              :max-date="maxDate"
              :range="true"
              :autoClose="true"
              :locale="this.$root.$i18n.locale"
              :color="$store.getters.getDatePickerColor"
              format="YYYY-MM-DDTHH:mm:ss"
              formatted="DD/MM/YYYY"
              :label="$t('text.calendar.selectDate')"
            />
          </div>
        </div> -->
      </div>

      <section class="pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowTextWrap="true"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :rowDataBound="rowDataBound"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="70" field="index" headerText="#"></e-column>
                <e-column
                  field="date"
                  width="200"
                  :format="formatOptions"
                  type="date"
                  :headerText="$t('text.cWallet.date')"
                ></e-column>
                <e-column
                  width="180"
                  field="amount"
                  format="N2"
                  :headerText="$t('text.cWallet.amount')"
                ></e-column>
                <e-column
                  field="walletBalance"
                  width="200"
                  :headerText="$t('text.bWallet.walletBalance')"
                ></e-column>
                <e-column
                  field="source"
                  width="200"
                  :headerText="$t('text.cWallet.source')"
                ></e-column>
                <e-column
                  field="status"
                  width="180"
                  :headerText="$t('text.cWallet.status')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Remis Wallet :: Epump Portal",
  name: "Remis Wallet",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      dateRange: {
        start: this.$moment().subtract(7, "days").format("YYYY-MM-DDTHH:mm:ss"),
        end: this.$moment().format("YYYY-MM-DDTHH:mm:ss"),
      },
      company: null,
      backgroundUrl,
      cardBackgroundUrl,
      companyId: null,
      comCountry: null,
      showLoader: true,
      remisTransact: [],
      walletBalance: +this.$route.query.balance,
      walletUnit: this.$route.query.unit,
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search", "ExcelExport", "PdfExport"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getWalletTransact();
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.updateRouteQuery();
        this.getWalletTransact();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
      this.companyId = this.$route.query.companyId
        ? this.$route.query.companyId
        : this.company.id;
      this.comCountry = this.company.country;
    });

    if (this.$route.query.startDate && this.$route.query.endDate) {
      this.dateRange.start = this.$route.query.startDate;
      this.dateRange.end = this.$route.query.endDate;
      console.log("daterange", this.dateRange);
      this.updateRouteQuery();
    } else {
      this.updateRouteQuery();
    }
  },
  beforeDestroy() {},
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    // this.updateRouteQuery();
  },
  methods: {
    updateRouteQuery() {
      let queries = JSON.parse(JSON.stringify(this.$route.query));
      queries.dateRange = JSON.stringify(this.dateRange);
      this.$router.replace({ query: queries });
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    rowDataBound: function (args) {
      if (args.data["status"] === "Debit") {
        args.row.cells[5].style.color = "red";
      }
      if (args.data["status"] === "Credit") {
        args.row.cells[5].style.color = "green";
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Wallet_Transaction_List.pdf",
          };
          this.$refs.dataGrid.getColumns()[0].width = "80";
          this.$refs.dataGrid.getColumns()[1].width = "200";
          this.$refs.dataGrid.getColumns()[2].width = "140";
          this.$refs.dataGrid.getColumns()[3].width = "200";
          this.$refs.dataGrid.getColumns()[4].width = "200";
          this.$refs.dataGrid.getColumns()[5].width = "200";
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          // this.$refs.dataGrid.getColumns()[4].visible = false;
          // this.$refs.dataGrid.getColumns()[5].visible = true;
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {},

    getWalletTransact() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/WalletTransactions/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.dateRange.start}&endDate=${this.dateRange.end}`,
          configObject.authConfig()
        )
        .then((response) => {
          // console.log(response);
          this.showLoader = false;
          this.remisTransact = response.data;
          let index = 0;
          response.data.sort((a, b) => {
            return b.date > a.date ? 1 : -1;
          });
          response.data.forEach((element) => {
            element.index = ++index;
            // element.dateUnformatted = element.date;
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style></style>
